export abstract class Mapper<Source, Target> {
  abstract from(source: Source): Target;
}
